export const FrontPageImages = [
    {
        "name": "logo",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/logo_a467d8758e.png"
    },
    {
        "name": "benefit3",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/benefit3_94b4c2f53f.png"
    },
    {
        "name": "dot",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/dot_c1f96e81ac.png"
    },
    {
        "name": "benefit2",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/benefit2_d5801539d3.png"
    },
    {
        "name": "store1",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/store1_c40083e67f.png"
    },
    {
        "name": "benefit1",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/benefit1_c0801748c0.png"
    },
    {
        "name": "store3",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/store3_d840649aeb.png"
    },
    {
        "name": "store2",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/store2_0e54cdd190.png"
    },
    {
        "name": "backstore1",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/backstore1_2f1bce1be4.png"
    },
    {
        "name": "mission_bg",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/mission_bg_a92c7afadb.jpg"
    },
    {
        "name": "backstore2",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/backstore2_9652c6cd78.png"
    },
    {
        "name": "backstore3",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/backstore3_63f36d6a6d.png"
    },
    {
        "name": "product",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/product_09613f12ce.jpg"
    },
    {
        "name": "banner",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/banner_69ec7989f7.jpg"
    },
    {
        "name": "hayseed",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/hayseed_140b401f5d.jpg"
    },
    {
        "name": "hay",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/hay_70d92b189d.jpg"
    },
    {
        "name": "straw",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/straw_02eef97452.jpg"
    },
    {
        "name": "sale",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/sale_0163af036f.png"
    },
    {
        "name": "straw1",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/default_0a174d27c8.jpeg"
    },
    {
        "name": "hero",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/hero_de60d583a3.jpg"
    },
    {
        "name": "mission",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/mission_ef54137462.png"
    },
    {

        "name": "haydefault",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/haydefault_b9391bf747.jpeg"
    },
    {
        "name": "auth-backgound",
        "url": "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/auth_backgound_326531477c.png"
    }
]